import { render, staticRenderFns } from "./CadCategorias.vue?vue&type=template&id=3de870ce&scoped=true&"
import script from "./CadCategorias.ts?vue&type=script&lang=ts&"
export * from "./CadCategorias.ts?vue&type=script&lang=ts&"
import style0 from "./categorias.scss?vue&type=style&index=0&id=3de870ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de870ce",
  null
  
)

export default component.exports